/**
 * Link al catalogo personalizzati: con la professione scelta nel cookie
 * (ik_profession) i collegamenti "generici" al catalogo portano alla pagina
 * della professione (/corsi-ecm/fad/ → /corsi-ecm/fad/psicologo/).
 *
 * Solo lato browser: Google e chi non ha scelto vedono i link normali.
 * Restano generici le briciole e i comandi che tolgono il filtro: sono la via
 * d'uscita verso il catalogo intero. Nessun redirect automatico.
 */
import { readProfession } from './profession-cookie.js';

const GENERIC = {
    '/corsi-ecm/':              '/corsi-ecm/{slug}/',
    '/corsi-ecm/fad/':          '/corsi-ecm/fad/{slug}/',
    '/corsi-ecm/residenziali/': '/corsi-ecm/residenziali/{slug}/',
};

const KEEP_GENERIC = '.ik-breadcrumb, .ik-filter-chip, .ik-search-result-info, .ik-profession-prompt, .ik-sidebar-filters';

export function personalizeCatalogLinks(root = document) {
    const known = readProfession();
    if (!known?.slug) return;

    root.querySelectorAll('a[href^="/corsi-ecm/"]').forEach((a) => {
        const target = GENERIC[a.getAttribute('href')];
        if (!target || a.closest(KEEP_GENERIC)) return;
        a.setAttribute('href', target.replace('{slug}', known.slug));
    });
}
